import angular from 'angular';
import laborCategoryDropdownComponent from './labor-category-dropdown.component';

let laborCategoryDropdownModule = angular.module('laborCategoryDropdown', [])
  .component('laborCategoryDropdown', laborCategoryDropdownComponent);

export default laborCategoryDropdownModule;




// WEBPACK FOOTER //
// ./client/common/directives/labor-category-dropdown/labor-category-dropdown.js